import React from 'react';
import styled from 'styled-components';
import { colors } from 'theme/Variables';

const StyledWrapper = styled.div`
    display: ${({ display }) => display || 'flex'};
    justify-content: ${({ justifyContent }) => justifyContent || 'center'};
    align-items: ${({ alignItems }) => alignItems || 'center'};
    flex-wrap: wrap;
    width: ${({ width }) => (width ? `${width}%` : '100%')};
    margin-top: ${({ mt }) => (mt ? `${mt}px` : '0px')};
    margin-bottom: ${({ mb }) => (mb ? `${mb}px` : '0px')};
    ${({ decorLeft }) =>
        decorLeft &&
        `
        border-left: 1px solid ${colors.secondary['200']};
        padding-left: 5px;
    `};
`;

const BoxWrapper = ({
    children,
    display,
    justifyContent,
    alignItems,
    width,
    decorLeft,
    mt,
    mb,
}) => {
    return (
        <StyledWrapper
            display={display}
            justifyContent={justifyContent}
            alignItems={alignItems}
            width={width}
            decorLeft={decorLeft}
            mt={mt}
            mb={mb}
        >
            {children}
        </StyledWrapper>
    );
};

export default BoxWrapper;
